<template>
  <div class="card-wrapper d-flex justify-content-center">
    <router-link :to="{name: route}" :disabled="!active">
      <div class="border-overlay">
      </div>
      <div class="card">
        <div class="card-body">
          <div class="title-container">
            <div class="d-flex justify-content-center align-items-center">
              <font-awesome-icon v-for="icon in icons"
                                 v-bind:key="icon.id"
                                 :icon="icon.name"
                                 :rotation="icon.rotation"
                                 class="title-icon">
              </font-awesome-icon>
            </div>
            <span class="card-title tk-orpheuspro">{{ header }}</span>
          </div>
          <div class="description-container">
            <span v-html="content"><span v-if="!active">&nbsp;(Inactive)</span></span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'HomeCard',
  props: {
    header: String,
    content: String,
    icons: Array,
    active: Boolean,
    route: String,
    placeholder: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
@import url("https://use.typekit.net/vfj7rbo.css");

.card-wrapper a {
  text-decoration: none;
  color: unset;
}

.border-overlay {
  width: 100%;
  height: 150px;
  border-radius: 10px;
  position: absolute;
  @media screen and (max-width: $break-lg - 1) {
    width: 176px;
    height: 137px;
  }
  @media screen and (min-width: $break-lg) {
    width: 216px;
    height: 168px;
  }
  @media screen and (min-width: $break-xl) {
    width: 256px;
    height: 199px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 299px;
    height: 232px;
  }
  @media screen and (min-width: $break-xxxl) {
    width: 352px;
    height: 232px;
  }
  z-index: 2;

  &:hover {
    border: 5px solid $home-card;
  }
}

.card {
  width: 100%;
  height: 150px;
  @media screen and (max-width: $break-lg - 1) {
    width: 176px;
    height: 137px;
  }
  @media screen and (min-width: $break-lg) {
    width: 216px;
    height: 168px;
  }
  @media screen and (min-width: $break-xl) {
    width: 256px;
    height: 199px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 299px;
    height: 232px;
  }
  @media screen and (min-width: $break-xxxl) {
    width: 352px;
    height: 232px;
  }
  border-radius: 10px;
  box-shadow: 0 3px 6px #000000CC;
  margin: 0;

  .card-body {
    padding: 0;
    color: $home-card;
    width: 100%;
    height: 100%;

    .title-container {
      height: 67%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      .title-icon {
        font-size: 74px;
        margin: 0 5px 20px;
        @media screen and (max-width: $break-lg - 1) {
          font-size: 34px;
          margin: 0 3px 6px;
        }
        @media screen and (min-width: $break-lg) {
          font-size: 46px;
          margin: 0 5px 8px;
        }
        @media screen and (min-width: $break-xl) {
          font-size: 58px;
          margin: 0 5px 10px;
        }
        @media screen and (min-width: $break-xxl) {
          font-size: 68px;
          margin: 0 5px 14px;
        }
        @media screen and (min-width: $break-xxxl) {
          font-size: 74px;
          margin: 0 5px 20px;
        }
      }

      .card-title {
        font-size: 34px;
        line-height: 40px;
        font-weight: 600;
        letter-spacing: 0;
        @media screen and (max-width: $break-lg - 1) {
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (min-width: $break-lg) {
          font-size: 22px;
          line-height: 28px;
        }
        @media screen and (min-width: $break-xl) {
          font-size: 28px;
          line-height: 34px;
        }
        @media screen and (min-width: $break-xxl) {
          font-size: 30px;
          line-height: 36px;
        }
        @media screen and (min-width: $break-xxxl) {
          font-size: 34px;
          line-height: 40px;
        }
      }
    }

    .description-container {
      height: 33%;
      padding: 0 5px;
      background-color: #F0F1F7;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 20px;
        line-height: 26px;
        font-weight: 400;
        letter-spacing: 0;
        text-align: center;
        @media screen and (max-width: $break-lg - 1) {
          font-size: 10px;
          line-height: 14px;
        }
        @media screen and (min-width: $break-lg) {
          font-size: 12px;
          line-height: 16px;
        }
        @media screen and (min-width: $break-xl) {
          font-size: 16px;
          line-height: 20px;
        }
        @media screen and (min-width: $break-xxl) {
          font-size: 18px;
          line-height: 22px;
        }
        @media screen and (min-width: $break-xxxl) {
          font-size: 20px;
          line-height: 26px;
        }
      }
    }
  }
}

a[disabled] {
  background-color: darkgray;
  pointer-events: none;
  cursor: default;
}

.card-wrapper {
  width: 25%;
  display: flex;
  justify-content: center;
  position: relative;
}
</style>
